module.exports = __webpack_public_path__ + "static/media/plant_feature.841213cf.png";